(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(datepickerConfig);

    datepickerConfig.$inject = ['$provide'];

    function datepickerConfig($provide) {

        $provide.decorator('uibDatepickerDirective', datepickerDecorator);

        datepickerDecorator.$inject = ['$delegate'];

        function datepickerDecorator($delegate) {
            angular.forEach($delegate, function (directive) {

                var originalCompile = directive.compile;
                var originalLink = directive.link;

                directive.templateUrl = 'app/shared/datepicker/datepicker.html';

                if (originalCompile) {
                    directive.compile = function () {
                        return function (scope) {
                            scope.$on('$localeChangeSuccess', function () {
                                scope.datepicker.refreshView();
                            });
                            originalLink.apply(this, arguments);
                        };
                    }
                }

            });
            return $delegate;
        }
    }
})();